import * as React from 'react';
import { useForm } from 'react-hook-form';
import { FormInput } from '@enginuity-apps-ui-components/molecules/form-elements/form-input/form-input';
import { Button } from '@enginuity-apps-ui-components/atoms/button/button';
import { ErrorList } from '@enginuity-apps-ui-components/molecules/form-elements/error-list/error-list';
import { ErrorPanel } from '@enginuity-apps-ui-components/atoms/error-panel/error-panel';
import { SettingsForApp } from '../../apps';

export type IRequestPasswordResetFormData = {
  username?: string;
};

export type IRequestPasswordResetFormProps = {
  onSubmit: (data: IRequestPasswordResetFormData) => void;
  submitError?: any;
  settingsForApp: SettingsForApp;
};

export default function RequestPasswordResetForm({ onSubmit, submitError, settingsForApp }: IRequestPasswordResetFormProps) {
  const { register, handleSubmit, errors } = useForm();

  return (<>
    <div className="row spacer-32">
      <div className="col-12">
        <h3>Reset Password</h3>
      </div>
    </div>
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row spacer-16">
        <div className="col-12">
          {settingsForApp.passwordResetMethod == 'email' && (
            <FormInput
              label={<>Email *</>}
              id="username"
              defaultValue=""
              ref={register({
                required: "Please enter your email for the account.", minLength: {
                  value: 5, message: 'Email length cannot be less than 5 characters'
                }, maxLength: {
                  value: 100, message: 'Email length cannot be more than 100 characters'
                },
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: "Please enter a valid email address"
                }
              })}
              errors={errors}
            />
          )}
          {settingsForApp.passwordResetMethod == 'username' && (
            <FormInput
              label={<>Username *</>}
              id="username"
              defaultValue=""
              ref={register({
                required: "Please enter your username for the account.",
              })}
              errors={errors}
            />
          )}
        </div>
      </div>

      <div className="row spacer-32">
        <div className="col-lg-12">
          <ErrorList errors={errors}>We found some errors. Please review the form and make the corrections.</ErrorList>
          {submitError && (
            <ErrorPanel>{submitError}</ErrorPanel>
          )}
        </div>
      </div>
      <div className="row spacer-32">
        <div className="col-lg-12">
          <Button buttonType="button" type="submit" className="cmp-button--secondary">Reset via email</Button>
        </div>
      </div>
    </form>
  </>
  );
}
